import * as t from 'io-ts';

export const createEnumType = <T extends string, TEnumValue extends string>(
    enumName: string,
    theEnum: { [key in T]: TEnumValue }
): t.Type<TEnumValue> => {
    const isEnumKey = (input: unknown): input is TEnumValue => Object.keys(theEnum).indexOf(input as string) !== -1;
    return new t.Type<TEnumValue>(
        enumName,
        isEnumKey,
        (input, context) => (isEnumKey(input) ? t.success(input) : t.failure(input, context)),
        t.identity
    );
};
